import isIOS from './isIOS';
import isAndroid from './isAndroid';

export default function isMobile() {
  return isIOS() || isAndroid() || /mobile/.test(navigator.userAgent.toLowerCase());
}
